<template>
  <div>
    <yv-index
      :path="path"
      :inlineSearchAction="true"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :tableActionsComponent="TableActions"
      :sortable="sortable"
      mainField="full_name"
      ref="templateTable"
    >
      <template #search-actions="{ actions }">
        <div class="flex justify-between">
          <md-button
            native-type="submit"
            @click="actions.search"
            class="md-info md-round"
          >
            {{ $t("common.search") }}
          </md-button>
          <md-button
            native-type="submit"
            @click="addNewTemplate"
            class="md-success md-round ml-auto"
          >
            {{ $t("common.add_new") }}
          </md-button>
        </div>
      </template>
    </yv-index>
    <!-- copy term -->
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import TableActions from "./tableAction.vue";
import Swal from "sweetalert2";
import { getId } from "@/helpers/utils";
import { mapState } from "vuex";

const defaultTemplate = () => ({
  name: null,
  content: "",
  variables: [],
  file: "",
  title: "",
  type: "email",
  variableSystem: [],
  attachments: [
    {
      name: ""
    }
  ]
});

export default {
  name: "ListPage",
  components: {
    YvIndex
  },
  data() {
    return {
      path: service_paths.communication_template,
      TableActions,
      formSearch: [
        {
          label: "communication.template_name",
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: "communication.type",
          name: "type",
          value: "",
          type: "select",
          options: [
            {
              id: "",
              name: "common.all"
            },
            {
              id: "email",
              name: "common.email"
            },
            {
              id: "announcement",
              name: "communication.announcement"
            },
            {
              id: "sms",
              name: "setting.sms"
            }
          ]
        }
      ],
      columns: {
        name: "communication.template_name",
        type: "communication.template_type",
        creatorName: "communication.templateCreator"
      },
      sortable: ["name", "type", "creatorName"],
      buttonAddNew: {
        title: "common.add_new",
        action: this.addNewTemplate
      },
      currentTemplate: defaultTemplate()
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  created() {},
  methods: {
    editTemplate(item) {
      let detailTemplate = Object.assign({}, item);
      this.$emit("edit-template", detailTemplate);
    },
    fetchDataTable() {
      this.$refs.templateTable.getTableData();
    },
    addNewTemplate() {
      this.currentTemplate = Object.assign(
        {
          creatorName: this.info.username,
          creatorId: getId(this.info)
        },
        defaultTemplate()
      );
      this.editTemplate(this.currentTemplate);
    },
    resetTemplateForm() {
      this.currentTemplate = Object.assign({}, defaultTemplate());
    },
    confirmDelete(item) {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("common.you_wont_be_able_to_revert_this"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes_delete_it"),
        cancelButtonText: this.$t("common.cancel"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteTemplate(item);
        }
      });
    },
    async deleteTemplate(data) {
      const id = data.id || data._id;
      const deleteTitle = this.$t("common.delete_success");
      this.$axios.delete(this.path + "/" + id).then(() => {
        // Reload table data
        this.$refs.templateTable.getTableData();
        this.$emit("async-template", data);
        Swal.fire({
          title: this.$t("common.deleted"),
          text: deleteTitle,
          type: "success",
          confirmButtonClass: "md-button md-success btn-fill",
          buttonsStyling: false
        });
      });
    }
  },
  provide() {
    return {
      editTemplate: this.editTemplate,
      confirmDelete: this.confirmDelete
    };
  }
};
</script>

<style scoped lang="scss">
.md-button {
  border-radius: 100px !important;
  float: right;
}
::v-deep .md-table-row td:nth-child(2) {
  width: 50%;
}
</style>
